(() => {
  const LABELS = {
    green: "Sofort verfügbar",
    yellow: "Niedriger Lagerbestand",
    red: "Aktuell ausverkauft",
  };

  const computeStatus = (variant, threshold) => {
    const tracked = !!variant?.inventory_management;
    const qty = typeof variant?.inventory_quantity === "number" ? variant.inventory_quantity : 0;

    // Wenn Bestand nicht getrackt: als verfügbar behandeln
    if (!tracked) return { status: "green", label: LABELS.green };

    if (qty <= 0) return { status: "red", label: LABELS.red };
    if (qty <= threshold) return { status: "yellow", label: LABELS.yellow };
    return { status: "green", label: LABELS.green };
  };

  const update = (wrapper, variantId) => {
    const statusEl = wrapper.querySelector("[data-traffic-status]");
    const jsonEl = wrapper.querySelector("[data-variants-json]");
    if (!statusEl || !jsonEl) return;

    let variants;
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch {
      return;
    }

    const threshold = parseInt(statusEl.getAttribute("data-threshold") || "5", 10);
    const variant = variants.find((v) => String(v.id) === String(variantId));
    if (!variant) return;

    const { status, label } = computeStatus(variant, threshold);

    statusEl.classList.remove("traffic-status--green", "traffic-status--yellow", "traffic-status--red");
    statusEl.classList.add(`traffic-status--${status}`);

    const textEl = statusEl.querySelector("[data-traffic-text]");
    if (textEl) textEl.textContent = label;
  };

  const getFormVariantId = (form) => form?.querySelector('input[name="id"]')?.value;

  const initWrapper = (wrapper) => {
    // passendes Formular finden (nächstes Add-to-cart-Form)
    const form =
      wrapper.closest("section")?.querySelector('form[action*="/cart/add"]') ||
      wrapper.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');

    const initialId = getFormVariantId(form);
    if (initialId) update(wrapper, initialId);

    // Update bei Änderungen (Dropdown/Radio)
    if (form) {
      form.addEventListener("change", (e) => {
        const t = e.target;
        if (
          t?.matches?.('select[name^="options["]') ||
          t?.matches?.('input[type="radio"]') ||
          t?.matches?.('input[name="id"]')
        ) {
          setTimeout(() => {
            const id = getFormVariantId(form);
            if (id) update(wrapper, id);
          }, 0);
        }
      });
    }

    // Dawn Event (falls vorhanden)
    document.addEventListener("variant:change", (event) => {
      const id = event?.detail?.variant?.id;
      if (id) update(wrapper, id);
    });
  };

  const boot = () => {
    document.querySelectorAll("[data-traffic-wrapper]").forEach(initWrapper);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();